import { render, staticRenderFns } from "./on-off-toggle.vue?vue&type=template&id=5daef0a6"
import script from "./on-off-toggle.vue?vue&type=script&lang=js"
export * from "./on-off-toggle.vue?vue&type=script&lang=js"
import style0 from "./on-off-toggle.vue?vue&type=style&index=0&id=5daef0a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports